import React from 'react';

const WhatsNext: React.FC = () => (
  <div className="max-w-4xl mx-auto px-4 py-8 w-full">
    <div className="bg-[#1a1a1a] border border-[#222] rounded-xl shadow-lg p-6 md:p-8">
        <h2 className="text-2xl font-bold mb-6 text-white">What's Next in Development?</h2>
        <ul className="list-disc pl-6 space-y-3 text-[#ccc] mb-8">
          <li>📈 Advanced analytics: more chart types, deeper sentiment breakdowns</li>
          <li>🔔 Telegram/Email notifications for top tickers and sentiment spikes</li>
          <li>💬 User accounts and personal watchlists</li>
          <li>🧠 Improved ML models for sentiment and trend prediction</li>
          <li>💡 More data sources: Twitter, YouTube, news</li>
          <li>📊 Real-time price and sentiment correlation</li>
          <li>🛠️ Public API documentation and widgets</li>
          <li>🌐 Multilingual support</li>
          <li>🤝 Community features: comments, voting, karma</li>
          <li>🚀 Mobile version</li>
          <li>⭐ Source karma: ranking authors, subreddits, channels by prediction accuracy</li>
          <li>🔗 Correlation of sentiment and price with karma and past predictions</li>
        </ul>
        <p className="mb-8 text-[#bbb] text-sm">Have ideas or want to contribute? Email <a href="mailto:info@sentihype.com" className="text-[#4ff6e6] hover:text-[#33e6d6] underline">info@sentihype.com</a></p>
        <div className="p-6 bg-[#333] border border-[#4ff6e6]/20 rounded-xl text-center">
          <p className="text-base text-white font-medium mb-2">Support SentiHype!</p>
          <p className="text-sm text-[#ccc] mb-4">If you like the project, you can help us grow and afford better servers.<br/>Any donation is appreciated 🙏</p>
          <a
            href="https://buymeacoffee.com/sentihype"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-[#4ff6e6] hover:bg-[#33e6d6] text-black font-semibold rounded-lg shadow-lg transition-colors duration-200"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 21a.75.75 0 01-.75-.75V19.5m0 0V5.25A2.25 2.25 0 019.75 3h4.5A2.25 2.25 0 0116.5 5.25V19.5m0 0v.75a.75.75 0 01-.75.75m-7.5 0h7.5m-7.5 0a3 3 0 01-3-3V7.5m13.5 12a3 3 0 003-3V7.5m-16.5 0h19.5" />
            </svg>
            Support on BuyMeACoffee
          </a>
          <p className="mt-3 text-xs text-[#888]">(Crypto/PayPal/other links coming soon — or email us for details)</p>
        </div>
    </div>
  </div>
);

export default WhatsNext; 